<script>import { onMount } from "svelte";
import { BROWSER, DEV } from "esm-env";
import { onlineManager, useQueryClient } from "@tanstack/svelte-query";
export let initialIsOpen = false;
export let buttonPosition = "bottom-right";
export let position = "bottom";
export let client = useQueryClient();
export let errorTypes = [];
export let styleNonce = void 0;
export let shadowDOMTarget = void 0;
let ref;
let devtools;
if (DEV && BROWSER) {
  onMount(() => {
    import("@tanstack/query-devtools").then((m) => {
      const QueryDevtools = m.TanstackQueryDevtools;
      devtools = new QueryDevtools({
        client,
        queryFlavor: "Svelte Query",
        version: "5",
        onlineManager,
        buttonPosition,
        position,
        initialIsOpen,
        errorTypes,
        styleNonce,
        shadowDOMTarget
      });
      devtools.mount(ref);
    });
    return () => {
      devtools?.unmount();
    };
  });
}
$: {
  if (devtools) {
    devtools.setButtonPosition(buttonPosition);
    devtools.setPosition(position);
    devtools.setInitialIsOpen(initialIsOpen);
    devtools.setErrorTypes(errorTypes);
  }
}
</script>

<div class="tsqd-parent-container" bind:this={ref}></div>
